/**
 * Module dependencies.
 */

import { BaseModal } from 'src/components/core/modal/base-modal';
import { StyledButton } from './service-payment';
import { Svg } from 'src/components/core/svg';
import { Text } from 'src/components/core/text';
import { useSchedule } from 'src/providers/schedule';
import { useTranslation } from 'next-i18next';
import alertSvg from 'src/assets/svgs/alert.svg';

/**
 * `ExitConfirmationModalProps` type.
 */

type ExitConfirmationModalProps = {
  handleContinue: () => void;
  handleExit: () => void;
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Export `ExitConfirmationModal` component.
 */

export const ExitConfirmationModal = ({ handleContinue, handleExit, isOpen, onClose }: ExitConfirmationModalProps) => {
  const { t } = useTranslation('schedule');
  const { isSantanderFlow } = useSchedule();

  const continueLabelKey = isSantanderFlow
    ? 'messages.exitConfirmationModal.santander.actions.continue'
    : 'messages.exitConfirmationModal.actions.continue';

  const exitLabelKey = isSantanderFlow
    ? 'messages.exitConfirmationModal.santander.actions.exit'
    : 'messages.exitConfirmationModal.actions.exit';

  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <Svg color={'var(--color-primary)'} icon={alertSvg} size={'38px'} style={{ marginBottom: 'var(--space-sm)' }} />

      <Text style={{ marginBottom: 'var(--space-xxs)', textAlign: 'center' }} variant={'titleL'} weight={600}>
        {t('messages.exitConfirmationModal.title')}
      </Text>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-xxs)',
          marginTop: 'var(--space-sm)',
          width: '100%'
        }}
      >
        <StyledButton aria-label={t(continueLabelKey)} onClick={handleContinue} size={'medium'} stretch>
          {t(continueLabelKey)}
        </StyledButton>

        <StyledButton aria-label={t(exitLabelKey)} colorTheme={'ghost'} onClick={handleExit} size={'medium'} stretch>
          {t(exitLabelKey)}
        </StyledButton>
      </div>
    </BaseModal>
  );
};
